export const config = {
    host: process.env.VUE_APP_URL ?? 'http://localhost:8000'
}
